package fr.frux.feature.treedetail

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Info
import androidx.compose.material.icons.outlined.WarningAmber
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.core.designsystem.theme.color
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_hazard_lookalike_note
import fr.frux.feature.treedetail.resources.treedetail_hazard_title
import fr.frux.shared.domain.model.SpeciesLookalike
import org.jetbrains.compose.resources.stringResource

/**
 * Niveau 4 (ADR 0015) : seul rouge de l'app, réservé au croisement sosie `LETHAL` × identification
 * non sûre — rare par construction. Tonalité `error` du thème, jamais une couleur codée en dur.
 */
@Composable
internal fun HazardWarningBanner(
    lookalikes: List<SpeciesLookalike>,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = MaterialTheme.colorScheme.errorContainer,
        shape = MaterialTheme.shapes.medium,
    ) {
        Row(
            modifier = Modifier.padding(FruxSpacing.md),
            horizontalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
        ) {
            Icon(
                imageVector = Icons.Outlined.WarningAmber,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onErrorContainer,
            )
            Column {
                Text(
                    text = stringResource(Res.string.treedetail_hazard_title),
                    style = MaterialTheme.typography.titleSmall,
                    color = MaterialTheme.colorScheme.onErrorContainer,
                )
                Spacer(Modifier.height(FruxSpacing.xs))
                lookalikes.forEach { lookalike ->
                    Text(
                        text =
                            stringResource(
                                Res.string.treedetail_hazard_lookalike_note,
                                lookalike.commonNameFr,
                                lookalike.distinguishingNote,
                            ),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onErrorContainer,
                    )
                }
            }
        }
    }
}

/**
 * Bandeau neutre "contesté" (#129 lot B, ADR 0015) : un signalement de pair est un doute de
 * terrain, jamais présenté comme un danger — jamais rouge, contrairement à [HazardWarningBanner].
 */
@Composable
internal fun DisputedBanner(
    text: String,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = MaterialTheme.colorScheme.surfaceVariant,
        shape = MaterialTheme.shapes.medium,
    ) {
        Row(
            modifier = Modifier.padding(FruxSpacing.md),
            horizontalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Icon(
                imageVector = Icons.Outlined.Info,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = text,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}
